import { render, staticRenderFns } from "./InsertComment.vue?vue&type=template&id=59723af2&"
import script from "./InsertComment.vue?vue&type=script&lang=js&"
export * from "./InsertComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports